import { ApiRouteDefinition } from '@auth0/auth0-angular/lib/auth.config';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { AuthConfig } from '@auth0/auth0-angular';
import { environment } from '@environment';

const domain = environment.apiUrl;

const privateControllers: string[] = [
	'integrations',
	'market/ec2',
	'frontend',
	'billing',
	'onboard',
	'azure',
	'azure-commitment-manager',
	'ebs-autoscaler',
	'zesty-disk',
	'zesty-disk-zsg',
	'zesty-disk-migration',
	'permission-manager',
	'cv-api',
	'unused-resources',
	'unused-resources-new',
	'policy-management-service',
	'potential-savings',
	'orgs-report',
	'notification-service',
	'cm',
	'notification-handlers',
	'zesty-disk/zdisk-live-billing',
	'admin',
	'v2/ec2',
	'action-maker',
	'potential-savings-v2',
	'database-explorer',
	'clusters/v1',
	'clusters/v2',
	'vpa',
	'partner',
	'auth',
	'discount',
	'rds-recommendations',
	'optimizationHub',
	'platform',
	'bff',
	'onboarding',
];

const privateEndpoints: string[] = [
	'internal/customer/check_permissions',
	'internal/customer/prepare_tasks',
	'auth2/resend-verify-email',
	'billing/get_detailed_report',
	'billing/get_bill_details',
	'billing/approve_bill',
	'billing/get_aws_marketplace_report',
	'billing/rerun_entity',
];

const allowedList: ApiRouteDefinition[] = [
	...privateControllers.map((controller: string) => `${domain}/${controller}/*`),
	...privateEndpoints.map((endpoint: string) => `${domain}/${endpoint}`),
];

export const auth0Config: Partial<AuthConfig> = {
	useRefreshTokens: true,
	audience: `${domain}/`,
	httpInterceptor: {
		allowedList,
	},
	skipRedirectCallback: window.location.pathname === AppRouteHelper.slackIntegration,
};
